/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Compliance_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "Compliance guardrails are now active and monitoring all requests" |
*
* @param {Audit_Details_Compliance_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_compliance_enabled_desc = /** @type {((inputs?: Audit_Details_Compliance_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Compliance_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance-Leitplanken sind jetzt aktiv und überwachen alle Anfragen")
	return /** @type {LocalizedString} */ ("Compliance guardrails are now active and monitoring all requests")
});